import {Component} from '@angular/core'
import {RequestListItemComponent} from '../request-list-item/request-list-item.component'

@Component({
  selector: 'spb-admin',
  templateUrl: './admin.component.html',
  imports: [RequestListItemComponent]
})
export class AdminComponent {
}
